import api from "./core";

const basePath = "api/core/DocumentNotes";
const extraHeader = { "Hide-Loading": true };

export default {
  get(id) {
    return api.get(`${basePath}/${id}`, extraHeader);
  },
  getDocumentNotes(documentId) {
    return api.get(`${basePath}/Document/${documentId}`, extraHeader);
  },
  create(data) {
    return api.put(`${basePath}`, data, extraHeader);
  },
  createBatch(data) {
    return api.put(`${basePath}/Batch`, data, extraHeader);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data, extraHeader);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`, extraHeader);
  }
};
